export default "__VITE_ASSET__SR6Vu3bU__"